import { createServerFn } from "@tanstack/react-start"
import {
  cancelAccessRequest as cancelAccessRequestService,
  requestAccess as requestAccessService,
} from "@apps/gwservice/access-requests"
import { getGroups as getGroupsService } from "@apps/gwservice/groups"
import { getMembers as getMembersService } from "@apps/gwservice/users"
import { Result } from "@praha/byethrow"
import { withAuth } from "../../auth/server/auth"

export const getMembers = createServerFn({
  method: "GET",
}).handler(() =>
  Result.try({
    try: () => getMembersService(),
    catch: () => "unexpected server error",
  }),
)

export const getGroups = createServerFn({
  method: "GET",
}).handler(() =>
  Result.try({
    try: () => withAuth(getGroupsService)(),
    catch: () => "unexpected server error",
  }),
)

export const requestAccess = createServerFn({
  method: "POST",
})
  .inputValidator((data: { kind: "group" | "event"; targetId: number }) => data)
  .handler(({ data }) => withAuth(requestAccessService)(data.kind, data.targetId))

export const cancelAccessRequest = createServerFn({
  method: "POST",
})
  .inputValidator((data: { kind: "group" | "event"; targetId: number }) => data)
  .handler(({ data }) => withAuth(cancelAccessRequestService)(data.kind, data.targetId))
